import { ThemeData } from '../types/ThemeData';
import { axios, get, post, put } from './baseAxios';
import {API_THEMES, API_TOURS} from '../utils/urls';

const url = API_THEMES;
const urlTours = API_TOURS;

export const getTheme = (id) => get(`${url}/${id}`);

export const filterThemes = (params) => get(url, { params });

export const updateTheme = (request) => put(url, request);

export const createTheme = (request) => post(url, request);

export const deleteTheme = (id) => axios.delete(`${url}/${id}`);

export const applyTheme = (tourId: number, themeDto: ThemeData) =>
  put(`${urlTours}/${tourId}/theme`, themeDto);
